import React , {Component} from 'react';
import BaseRouter from "./routes";
import "semantic-ui-css/semantic.min.css";
import "./App.scss";
import { BrowserRouter as Router } from "react-router-dom";
import { Modal} from "semantic-ui-react";
import {ModalProvider} from "./components/ModalContext";
import RegisterForm from "./components/RegisterForm";
import MyComponent from 'react-fullpage-custom-loader';
import Loader from './assets/images/loader1.gif';
import { SemanticToastContainer, toast } from 'react-semantic-toasts';
import 'react-semantic-toasts/styles/react-semantic-alert.css';
import ReactGA from 'react-ga';
import RouteChangeTracker from "./components/GA";
import Schedule from "./components/Schedule";

const TRACKING_ID = "UA-105307113-3";
if(process.env.NODE_ENV !== 'development')
    ReactGA.initialize(TRACKING_ID);



class App extends Component{

   constructor() {
       super();
       this.state={
           show:false,
           showSchedule:false,
           setShowSchedule:(val)=>{
               this.setState({showSchedule:val})
           },
           setShow:(val)=>{
               this.setState({show:val})
           },
           loaded:false,
           setLoaded:(val)=>{
               this.setState({loaded:val})
           },
           redirect:false,
           setRedirect:(val)=>{
               this.setState({redirect:val})
           }
       }
   }



   componentDidMount() {
       window.addEventListener('load',()=>{
           this.setState({loaded:true})
           document.querySelector('body.loading').classList.remove('loading')
           document.getElementById('main-loader').style.display = 'none';
       })
   }

   componentWillUnmount() {
       window.removeEventListener('load',()=>{
           this.setState({loaded:true})
       })
       // this.setState(false)
   }

    render(){
      return (
          <>
              {/*{!this.state.loaded && <MyComponent  wrapperBackgroundColor={'rgba(4,2,5,1)'}*/}
              {/*                                    customLoader={<img src={Loader}/>} sentences={[]} />}*/}

              <Router>
                  {console.log(this.props)}
                  <ModalProvider value={this.state}>
                      {process.env.NODE_ENV === 'development' ? null : <RouteChangeTracker/>}
                      <BaseRouter />

                      <Modal
                          size={'tiny'}
                          open={this.state.showSchedule}
                          onClose={() => this.state.setShowSchedule(false)}
                          closeIcon={true}
                          className={'schedule-modal'}
                          style={{zIndex:'99'}}

                      >
                          <Modal.Header className={'modal-header'}>Schedule</Modal.Header>
                          <Modal.Content className={'modal-content'}>
                              <Schedule/>
                          </Modal.Content>

                      </Modal>
                  </ModalProvider>


              </Router>

              <SemanticToastContainer position={'top-center'}/>



              <Modal
                  size={'tiny'}
                  open={this.state.show}
                  onClose={() => this.state.setShow(false)}
                  closeIcon={true}
                  className={'modal'}
                  style={{zIndex:'99'}}

              >
                  <Modal.Header className={'modal-header'}>REGISTER</Modal.Header>
                  <Modal.Content className={'modal-content'}>
                      <RegisterForm setShow={this.state.setShow}/>
                  </Modal.Content>

              </Modal>


              

          </>
      );
  }
}

export default App;
